var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#7BBF6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 24.6C12.4 25.5 14.2 26 16 26C21.5 26 26 21.5 26 16C26 10.5 21.5 6 16 6C10.5 6 6 10.5 6 16C6 17.8 6.5 19.5 7.3 21L6.44044 24.306C6.24572 25.0549 6.93892 25.7317 7.68299 25.5191L10.9 24.6Z",
    fill: "#7BBF6A",
    stroke: "#F1F1F1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 18.8485C20.5 19.0105 20.4639 19.177 20.3873 19.339C20.3107 19.501 20.2116 19.654 20.0809 19.798C19.86 20.041 19.6167 20.2165 19.3418 20.329C19.0714 20.4415 18.7784 20.5 18.4629 20.5C18.0033 20.5 17.512 20.392 16.9937 20.1715C16.4755 19.951 15.9572 19.654 15.4434 19.2805C14.9251 18.9025 14.4339 18.484 13.9652 18.0205C13.501 17.5525 13.0819 17.062 12.7078 16.549C12.3383 16.036 12.0408 15.523 11.8245 15.0145C11.6082 14.5015 11.5 14.011 11.5 13.543C11.5 13.237 11.5541 12.9445 11.6622 12.6745C11.7704 12.4 11.9417 12.148 12.1805 11.923C12.469 11.6395 12.7844 11.5 13.1179 11.5C13.2441 11.5 13.3703 11.527 13.483 11.581C13.6002 11.635 13.7038 11.716 13.7849 11.833L14.8305 13.3045C14.9116 13.417 14.9702 13.5205 15.0108 13.6195C15.0513 13.714 15.0739 13.8085 15.0739 13.894C15.0739 14.002 15.0423 14.11 14.9792 14.2135C14.9206 14.317 14.835 14.425 14.7268 14.533L14.3843 14.8885C14.3348 14.938 14.3122 14.9965 14.3122 15.0685C14.3122 15.1045 14.3167 15.136 14.3257 15.172C14.3393 15.208 14.3528 15.235 14.3618 15.262C14.4429 15.4105 14.5826 15.604 14.7809 15.838C14.9837 16.072 15.2 16.3105 15.4344 16.549C15.6778 16.7875 15.9121 17.008 16.151 17.2105C16.3853 17.4085 16.5791 17.5435 16.7323 17.6245C16.7549 17.6335 16.7819 17.647 16.8135 17.6605C16.8495 17.674 16.8856 17.6785 16.9261 17.6785C17.0028 17.6785 17.0613 17.6515 17.1109 17.602L17.4534 17.2645C17.5661 17.152 17.6743 17.0665 17.7779 17.0125C17.8816 16.9495 17.9852 16.918 18.0979 16.918C18.1835 16.918 18.2737 16.936 18.3728 16.9765C18.472 17.017 18.5756 17.0755 18.6883 17.152L20.18 18.2095C20.2972 18.2905 20.3783 18.385 20.4279 18.4975C20.473 18.61 20.5 18.7225 20.5 18.8485Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.7bf89c4115a0bfbb1fd3829f8ae6081a.svg";
export { ForwardRef as ReactComponent };